import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

interface SetBasketItemArguments extends ShopTypes.BasketItemOptions {
    itemNo: string | undefined;
    reference: string | undefined;
}

export default function setBasketItem({ itemNo, reference, ...rest }: SetBasketItemArguments) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    if (!itemNo) {
        return Promise.reject(new Error(shopErrors.invalidProductItemNumber.message));
    }
    return shop
        .post(getUrl(`/baskets/${reference}/set/${itemNo}`), {
            json: rest as ShopTypes.BasketItemOptions,
        })
        .json<ShopTypes.BasketResponse>();
}
